// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e0ed1185","239":"21edf374","453":"d6ddee16","667":"78f18c5c"}[chunkId] + ".chunk.js";
};